module.exports = __webpack_public_path__ + "static/media/subnav-developer.04a4225c.svg";